<main>
  <h4>
    <span>
      {{ demandeContact.objet }}
    </span>
    @if (demandeContact.patient && afficherPatient) {
      <tui-chip appearance="primary">
        {{ demandeContact.patient!.nom }}
        {{ demandeContact.patient!.prenom }}</tui-chip
      >
    }
  </h4>
  <div>
    <p>
      {{ demandeContact.message }}
    </p>
    @if (demandeContact.pdf) {
      <button
        type="button"
        iconStart="@tui.link"
        size="s"
        appearance="outline"
        tuiButton
        (click)="openLast(actions)"
      >
        Pièce jointe
      </button>
    }
  </div>
</main>
<aside>
  {{ demandeContact.date | date: "dd/MM/yyyy" }} à
  {{ demandeContact.date | date: "HH:mm" }}
</aside>

<ng-template #actions let-content="content">
  <a download size="s" tuiButton [href]="content"> Télécharger </a>
</ng-template>
